import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbCarousel, NgbCarouselConfig, NgbSlide } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { AuthService } from '../../core/services/auth.service';
import { UserPersistenceService } from '../../core/services/userPersistence.service';
import { ParentChildCommunicationService } from '../../shared/services/parent-child-communication.service';


@Component({
    selector: '[ifc-show-image-preview]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './show-image-preview-modal.component.html',
    styleUrls: ['./show-image-preview-modal.component.scss'],
    host: { 'class': 'ps-5 pe-5' },
    providers: [NgbCarouselConfig],
    standalone: true,
    imports: [NgbCarousel, NgbSlide]
})

export class ShowImagePreviewModalComponent implements OnInit, OnDestroy {

    public selectedImage: any;
    heading: string = '';
    action: Subject<any> = new Subject();
    public allImages: any = [];
    swatchesImagesPath: string = "";
    public isShowImageName: boolean = true;
    constructor(
        public modalRef: MDBModalRef,
        public authService: AuthService,
        public userPersistenceService: UserPersistenceService,
        public parentChildCommunicationService: ParentChildCommunicationService,
        private config: NgbCarouselConfig,
        private sanitizer: DomSanitizer
    ) {
        config.interval = 0;
    }

    ngOnInit() {

    }

    ngOnDestroy() {

    }

    onCancelClick() {
        this.modalRef.hide();
        this.action.next('Cancel');
    }

    sanitize(url: string) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    onImgError(event) {
        event.target.src = './assets/images/no-project-image.png';
        //Do other stuff with the event.target
    }
};